module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Bellikon_AG-d557d48e4c002a489b3f4177c6466d7d.svg";